module.exports = __webpack_public_path__ + "8b1c0004.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/searchSubHomeIcon.jpeg
// module id = 2871
// module chunks = 20